import { ImportTypeConfig } from '#/store/hooks/useForms/Import/types/ImportTypeConfig'

export const lely: ImportTypeConfig = {
  dateFormat: { default: 'D_M_YYYY_DOT' },
  importType: true,
  instructions: {
    dateInstructionKey: 'select_date_of_milk_production_instruction',
    software: 'Lely',
    spreadsheetName: { lower: true, messageKey: 'exportable' },
  },
  type: 'lely',
}
